import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5eee72a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "practice-people-authorised-trust-contact" }
const _hoisted_2 = { class: "search-inputs" }
const _hoisted_3 = { class: "search-bar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-hm" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-filter fa-lg" })
], -1))
const _hoisted_5 = { class: "checkbox-button ml-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "checkbox-elmt",
  style: {"border":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "checkmark-box",
    style: {"align-self":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "checkmark" })
  ]),
  /*#__PURE__*/_createElementVNode("span", { class: "checkbox-text" }, "Show active only")
], -1))
const _hoisted_7 = { class: "ls-table" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-up" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["colspan"]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = ["colspan"]
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { "data-label": "LawID" }
const _hoisted_20 = { "data-label": "Name" }
const _hoisted_21 = { "data-label": "Email" }
const _hoisted_22 = { "data-label": "From" }
const _hoisted_23 = { "data-label": "To" }
const _hoisted_24 = { "data-label": "Action" }
const _hoisted_25 = ["onClick", "disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_ConfirmDialogue = _resolveComponent("ConfirmDialogue")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.searchKeyword) = $event)),
          placeholder: "Filter by LawID or name"
        }, null, 512), [
          [_vModelText, _ctx.searchKeyword]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("label", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showActiveOnly) = $event))
        }, null, 512), [
          [_vModelCheckbox, _ctx.showActiveOnly]
        ]),
        _hoisted_6
      ])
    ]),
    _createElementVNode("table", _hoisted_7, [
      _createElementVNode("thead", null, [
        _createElementVNode("tr", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableHeadings, (h, index) => {
            return (_openBlock(), _createElementBlock("th", {
              class: _normalizeClass([ h.sortable ? 'sortable' : '']),
              onClick: $event => (_ctx.sortTableColumn(index, h.sortable))
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(h.text), 1),
                (h.sortable)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass([ _ctx.activeSortHeader === index ? 'active' : '', _ctx.sortMethod])
                    }, _hoisted_11, 2))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_8))
          }), 256))
        ])
      ]),
      _createElementVNode("tbody", null, [
        (_ctx.loadingContent)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
              _createElementVNode("td", {
                colspan: _ctx.tableHeadings.length
              }, [
                _createVNode(_component_LoadingIndicator)
              ], 8, _hoisted_13)
            ]))
          : (_ctx.errorLoadingContent)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                _createElementVNode("td", {
                  colspan: _ctx.tableHeadings.length
                }, [
                  _createVNode(_component_ErrorIndicator)
                ], 8, _hoisted_15)
              ]))
            : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.trustContactsDisplay.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                  _createElementVNode("td", {
                    colspan: _ctx.tableHeadings.length
                  }, "No Records", 8, _hoisted_17)
                ]))
              : (!_ctx.loadingContent && !_ctx.errorLoadingContent && _ctx.trustContactsDisplay.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.applyFilter(_ctx.trustContactsDisplay), (i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (_ctx.showActiveOnly && _ctx.isActive(i) || !_ctx.showActiveOnly)
                        ? (_openBlock(), _createElementBlock("tr", _hoisted_18, [
                            _createElementVNode("td", _hoisted_19, _toDisplayString(i.lawId), 1),
                            _createElementVNode("td", _hoisted_20, _toDisplayString(i.name), 1),
                            _createElementVNode("td", _hoisted_21, _toDisplayString(i.email), 1),
                            _createElementVNode("td", _hoisted_22, _toDisplayString(i.effectiveStartDate ? _ctx.$formatDate(i.effectiveStartDate) : ''), 1),
                            _createElementVNode("td", _hoisted_23, _toDisplayString(i.effectiveEndDate ? _ctx.$formatDate(i.effectiveEndDate) : ''), 1),
                            _createElementVNode("td", _hoisted_24, [
                              _createElementVNode("button", {
                                class: "btn btn-default sml ml-1",
                                onClick: $event => (_ctx.deleteTrustContact(i)),
                                disabled: i.effectiveEndDate
                              }, "Delete", 8, _hoisted_25)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_ConfirmDialogue, {
      ref: "confirmDeleteDialogue",
      modalOpened: true
    }, null, 512)
  ]))
}